module.exports = __webpack_public_path__ + "static/img/icon_zylx06.7945b058.png";